import { ChangeEvent, MouseEvent } from "react";
import { CheckboxProps } from "./types";

const useCheckbox = (
  id: string,
  handleOnChange?: CheckboxProps["handleOnChange"]
) => {
  const onChangeCheckBox = (e: ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const checkedStatus = e.target.checked;
    handleOnChange?.(id, checkedStatus);
  };

  const stopPropagation = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return {
    onChangeCheckBox,
    stopPropagation,
  };
};

export default useCheckbox;
